var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "bob-core-components-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/_tint/location-"
  }, /*#__PURE__*/React.createElement("path", {
    className: "tertiarytint",
    d: "M13 5.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 1 0 0-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondarytint",
    d: "M12 20.5a3 1.25 0 1 0 0 2.5 3 1.25 0 1 0 0-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 7c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-11c-4.4 0-8 3.6-8 8 0 4.75 6 10.55 7.6 11.85.1.1.25.15.4.15.15 0 .3-.05.4-.15C14 20.55 20 14.75 20 10c0-4.4-3.6-8-8-8zm0 18.9c-1.6-1.3-7-6.75-7-10.9 0-3.85 3.15-7 7-7s7 3.15 7 7c0 4.15-5.4 9.6-7 10.9z",
    className: "primarytint"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.baac305d258a18681b75dcbb417b488d.svg";
export { ForwardRef as ReactComponent };